
import React, {ReactElement, useContext} from 'react';
import classes from "./ManageDocumentGroups.module.css";
import EmptyModal from '../../../components/Modals/EmptyModal';
import { DocumentGroup } from '../../../utils/interface';
import Button from '../../../components/Button/Button';
import useWindowSize from '../../../customHooks/useWindowSize';
import { Store } from '../../../Store';
import { useOutletContext } from 'react-router-dom';
import { DocumentsModuleOutletInterface } from '../../Documents/DocumentsModuleContainer';

interface NewGroupConfirmationModalProps {
    type: string;
    shown: boolean;
    reportType: DocumentGroup|null;
    onClose: () => void;
    addNewGroup: () => void;
    addNewDocument: () => void;
}

function NewGroupConfirmationModal(props: NewGroupConfirmationModalProps) {
    const {isMobile} = useWindowSize();
    const {selectedPlant} = useContext(Store);
    const {documentModule} = useOutletContext<DocumentsModuleOutletInterface>();
    
    let width: number = 564;
    if (isMobile) {
        width = 300;
    }
    let modalBody: ReactElement|undefined;
    let modalFooter: ReactElement|undefined;
    if (props.shown) {
        modalBody = (
                <span className={classes.modal_body_text}>"{props.reportType?.name}" was successfully added as a new {props.type.toLowerCase()} document group.</span>
        );

        modalFooter = (
            <>
                <div className={`${classes.modal_button_group} ${classes.flex_row}`}>
                    <Button className="darkBlue" text="Add Another Group" onClick={props.addNewGroup} />
                    <Button className="whiteBtn" text="Add Document" onClick={props.addNewDocument} />
                    <button className={`${classes.done_button} ${classes.flex_row}`} onClick={props.onClose}>Done</button>
                </div>
            </>
        );
    }

    return (
        <EmptyModal shown={props.shown} body={modalBody} footer={modalFooter} heading={<div style={{textAlign: "center"}}><div>{`${props.type} Document Group`}</div><div>{`Successfully Added`}</div></div>} onClose={props.onClose} width={width} footerClass={classes.modal_footer} />
    );
}

export default NewGroupConfirmationModal;